export default {
  // Header
  "title": "Random Pokemon Generator",
  "subtitle": "Generate random Pokémon based on your preferences",
  "home": "Home",
  "whichPokemonAmI": "Which Pokémon Am I?",
  
  // Filters
  "filterTitle": "Filter Options",
  "generateButton": "Generate Random Pokémon",
  "generating": "Generating...",
  "numberOfPokemon": "Number of Pokémon",
  "type": "Type",
  "generation": "Generation",
  "minimumRarity": "Minimum Rarity (1-10)",
  "anyType": "Any Type",
  "anyGeneration": "Any Generation",
  "anyRarity": "Any Rarity",
  "countingPokemon": "Counting matching Pokémon",
  "matchingPokemonCount": "{{count}} Pokémon match your filters",
  "noPokemonToDisplay": "No Pokémon to display. Generate some Pokémon!",
  
  // Pokemon Types
  "normal": "Normal",
  "fire": "Fire",
  "water": "Water",
  "electric": "Electric",
  "grass": "Grass",
  "ice": "Ice",
  "fighting": "Fighting",
  "poison": "Poison",
  "ground": "Ground",
  "flying": "Flying",
  "psychic": "Psychic",
  "bug": "Bug",
  "rock": "Rock",
  "ghost": "Ghost",
  "dragon": "Dragon",
  "dark": "Dark",
  "steel": "Steel",
  "fairy": "Fairy",
  
  // Generations
  "Generation I": "Generation I",
  "Generation II": "Generation II",
  "Generation III": "Generation III",
  "Generation IV": "Generation IV",
  "Generation V": "Generation V",
  "Generation VI": "Generation VI",
  "Generation VII": "Generation VII",
  "Generation VIII": "Generation VIII",
  "Generation IX": "Generation IX",
  
  // Evolution Stage
  "evolutionStage": "Evolution Stage",
  "evolutionStageAll": "All Stages",
  "evolutionStageFullyEvolved": "Fully Evolved",
  "evolutionStageNotFullyEvolved": "Not Fully Evolved",
  
  // About Section
  "aboutTitle": "About the Random Pokémon Generator",
  
  // Section titles
  "introTitle": "Welcome to Our Random Pokémon Generator",
  "howToUseTitle": "How to Use the Random Pokémon Generator",
  "benefitsTitle": "Benefits of Using Our Random Pokémon Generator",
  "historyTitle": "History of Pokémon",
  "popularPokemonTitle": "Popular Pokémon",
  "popularGamesTitle": "Popular Pokémon Games",
  "tradingContestsTitle": "Pokémon Trading and Contests",
  "faqTitle": "Frequently Asked Questions",
  "conclusionTitle": "Start Your Random Pokémon Adventure Today!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Pokémon and Pokémon character names are trademarks of Nintendo.",
  "linksTitle": "Useful Links",
  "aboutUs": "About Us",
  "contactUs": "Contact Us",
  "privacyPolicy": "Privacy Policy",
  
  // Which Pokemon Am I Feature
  "enterDetails": "Enter Your Details",
  "nameLabel": "Name",
  "namePlaceholder": "Enter your name",
  "heightLabel": "Height",
  "weightLabel": "Weight",
  "findMyPokemon": "Find My Pokémon",
  "finding": "Finding...",
  "nameRequired": "Name is required",
  "heightValid": "Please enter a valid height (1-300 cm)",
  "weightValid": "Please enter a valid weight (1-500 kg)",
  "errorFinding": "Error finding your Pokémon match",
  "matchResult": "{{name}}'s Pokémon is...",
  "similarityScore": "Similarity Score",
  "downloadImage": "Download Image",
  "downloadStarted": "Preparing your image...",
  "downloadComplete": "Image downloaded successfully!",
  "shareText": "I found out I'm {{pokemon}}! Find your Pokémon match too!",
  "tryAgain": "Try Again",
  "enterHeightWeight": "Enter your height and weight — see which Pokémon matches you!",
  "whichPokemonMatchesSize": "Which Pokémon matches your size?",
  "youAreMostLike": "You're most like",
  "madeBy": "Made by",
  
  // Which Pokemon Am I Content Sections
  "aboutTool": "About This Tool",
  "howToUse": "How To Use",
  "benefits": "Benefits",
  "faq": "Frequently Asked Questions",
  "conclusion": "Conclusion",

  // About Us Page
  "aboutUsTitle": "About Us",
  "aboutUsWhoWeAre": "Who We Are",
  "aboutUsWhoWeAreContent1": "Welcome to Random Pokémon Generator, a fan-made tool created by passionate Pokémon enthusiasts. Our journey began in 2023 when a group of developers who loved both programming and Pokémon decided to create a helpful tool for the community.",
  "aboutUsWhoWeAreContent2": "Our team consists of developers, designers, and content creators who work together to provide the best possible experience for Pokémon fans around the world.",
  "aboutUsOurMission": "Our Mission",
  "aboutUsOurMissionContent1": "We aim to make the world of Pokémon more accessible and enjoyable for everyone. Our tools are designed to help trainers discover new Pokémon, create balanced teams, and find their perfect Pokémon match.",
  "aboutUsOurMissionContent2": "We are committed to providing a user-friendly, accurate, and fun experience that respects the Pokémon franchise while adding value to the community.",
  "aboutUsOurTeam": "Our Team",
  "aboutUsOurTeamContent1": "Our diverse team brings together expertise in web development, Pokémon knowledge, user experience design, and community management. We're united by our love for Pokémon and our commitment to creating high-quality tools.",
  "aboutUsOurTeamContent2": "Each team member contributes their unique skills and perspectives to make Random Pokémon Generator the best it can be.",
  "aboutUsJoinUs": "Join Us",
  "aboutUsJoinUsContent": "We're always looking for passionate individuals to join our community. Whether you're a developer, designer, Pokémon expert, or enthusiastic user, your feedback and contributions are welcome.",

  // Contact Us Page
  "contactUsTitle": "Contact Us",
  "contactUsGetInTouch": "Get In Touch",
  "contactUsGetInTouchContent": "Have questions, suggestions, or feedback about Random Pokémon Generator? We'd love to hear from you! Here's how you can reach out to our team.",
  "contactUsEmail": "Email",
  "contactUsPhone": "Phone",
  "contactUsAddress": "Address",
  "contactUsHelpSupport": "Help & Support",
  "contactUsHelpSupportContent": "Need assistance with using our tools or have encountered an issue? Our support team is here to help.",
  "contactUsFAQ": "Frequently Asked Questions",
  "contactUsFAQContent": "Before reaching out, check our FAQ section which covers many common questions and issues.",
  "contactUsBugReport": "Report a Bug",
  "contactUsBugReportContent": "If you've found a bug or technical issue, please let us know by sending an email with 'BUG REPORT' in the subject line.",

  // Privacy Policy Page
  "privacyPolicyTitle": "Privacy Policy",
  "privacyPolicyIntro": "Introduction",
  "privacyPolicyIntroContent": "At Random Pokémon Generator, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website.",
  "privacyPolicyInformation": "Information We Collect",
  "privacyPolicyInformationContent": "We collect minimal information to provide and improve our services. This may include:",
  "privacyPolicyInformationItem1": "Usage data (such as pages visited, time spent on the site, and features used)",
  "privacyPolicyInformationItem2": "Device information (browser type, operating system, and screen resolution)",
  "privacyPolicyInformationItem3": "IP address and approximate location (country level only)",
  "privacyPolicyCookies": "Cookies and Similar Technologies",
  "privacyPolicyCookiesContent": "We use cookies to enhance your experience on our website. These small text files allow us to remember your preferences and analyze how our site is used. You can control cookies through your browser settings.",
  "privacyPolicyThirdParty": "Third-Party Services",
  "privacyPolicyThirdPartyContent": "Our website may use third-party services such as analytics providers and content delivery networks. These services may collect information about your use of our website. We ensure all third parties respect your privacy and handle data appropriately.",
  "privacyPolicySecurity": "Data Security",
  "privacyPolicySecurityContent": "We implement appropriate security measures to protect your information from unauthorized access, alteration, or disclosure. However, no internet transmission is 100% secure, so we cannot guarantee absolute security.",
  "privacyPolicyChanges": "Changes to This Policy",
  "privacyPolicyChangesContent": "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the 'last updated' date.",
  "privacyPolicyContact": "Contact Us",
  "privacyPolicyContactContent": "If you have any questions about this Privacy Policy, please contact us through the information provided on our Contact page.",
  "privacyPolicyLastUpdated": "Last Updated",

  // New Page: Pokemon Randomizer - About Section Titles
  "pokemonRandomizerPageAboutTitle": "Explore the Ultimate Pokémon Randomizer Experience",
  "pokemonRandomizer_whatIsItTitle": "What Exactly Is a Pokémon Randomizer?",
  "pokemonRandomizer_featuresTitle": "Key Features of Our Pokémon Randomizer Tool",
  "pokemonRandomizer_whyUseTitle": "Why Embark on an Adventure with a Pokémon Randomizer?",
  "pokemonRandomizer_gettingStartedTitle": "Getting Started: Your First Pokémon Randomizer Run",
  "pokemonRandomizer_faqTitle": "Pokémon Randomizer: Frequently Asked Questions",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle
  "pokemonRandomizerPageH1": "Pokémon Randomizer",
  "pokemonRandomizerPageSubtitle": "Create unique Pokémon experiences with our advanced randomizer tool.",

  // Sub-Footer
  "subFooterToolsTitle": "Tools",
  "subFooterRandomPokemonGeneratorLink": "Random Pokémon Generator",
  "subFooterPokemonRandomizerLink": "Pokémon Randomizer",
  "subFooterWhichPokemonAmILink": "Which Pokémon Am I?",

  "subFooterPokemonDatabaseTitle": "Pokémon Database",
  "subFooterPokedexLink": "Pokédex (Coming Soon)",
  "subFooterTypeChartsLink": "Type Charts",
  "subFooterMoveListLink": "Move List (Coming Soon)",

  "subFooterBlogTitle": "Blog",
  "subFooterLatestArticlesLink": "Latest Articles (Coming Soon)",
  "subFooterGuidesTutorialsLink": "Guides & Tutorials (Coming Soon)",

  "pokedexEyebrow": "Pok\u00e9mon Database",
  "pokedexPageTitle": "Pok\u00e9dex",
  "pokedexPageSubtitle": "Search every Pok\u00e9mon, filter by type or generation, and open a richer detail view without leaving the page.",
  "pokedexSearchLabel": "Search",
  "pokedexSearchPlaceholder": "Search by name or Pok\u00e9dex number",
  "pokedexAllGenerations": "All Generations",
  "pokedexAllTypes": "All Types",
  "pokedexSortLabel": "Sort",
  "pokedexSortNumber": "Lowest Number",
  "pokedexSortName": "Name A-Z",
  "pokedexSortRarity": "Highest Rarity",
  "pokedexSortHeight": "Tallest First",
  "pokedexSortWeight": "Heaviest First",
  "pokedexClearFilters": "Clear Filters",
  "pokedexTotalEntries": "Total Entries",
  "pokedexFilteredEntries": "Matches",
  "pokedexPageIndicator": "Page",
  "pokedexInspect": "Inspect",
  "pokedexShowingResults": "Showing {{start}}-{{end}} of {{total}} entries",
  "pokedexPrevious": "Previous",
  "pokedexNext": "Next",
  "pokedexPageStatus": "Page {{page}} / {{total}}",
  "pokedexEmptyTitle": "No Pok\u00e9mon matched this search",
  "pokedexEmptyBody": "Try a different name, generation, or type filter. The full database is still available.",
  "pokedexLoadErrorTitle": "Pok\u00e9dex data could not be loaded",
  "pokedexLoadErrorBody": "The local Pok\u00e9mon database was unavailable, so the Pok\u00e9dex cannot render right now.",
  "pokedexDetailDescription": "Detailed Pok\u00e9dex entry",
  "pokedexDetailError": "Unable to load this Pok\u00e9mon entry right now.",
  "pokedexDetailLoading": "Loading Pok\u00e9dex entry...",
  "pokedexOverviewTitle": "Overview",
  "pokedexBaseExperience": "Base Experience",
  "pokedexAbilitiesTitle": "Abilities",
  "pokedexStatsTitle": "Base Stats",
  "pokedexMovesTitle": "Featured Moves",
  "pokedexMovesLearnset": "Learnset",
  "pokedexMovesUnavailable": "Move details were unavailable for this entry.",
  "pokedexMovesPower": "Power",
  "pokedexMovesAccuracy": "Accuracy",
  "pokedexMovesPP": "PP",
  "pokedexMovesPriority": "Priority",
  "pokedexMovesEffect": "Effect",
  "pokedexMovesEffectFallback": "No effect text was available for this move in the current language.",
  "pokedexMovesRoutes": "Learn Routes",
  "pokedexMovesLevel": "Level",
  "pokedexMoveMethodLevelUp": "Level Up",
  "pokedexMoveMethodMachine": "Machine",
  "pokedexMoveMethodEgg": "Egg",
  "pokedexMoveMethodTutor": "Tutor",
  "pokedexMoveMethodEvolution": "Evolution",
  "pokedexMoveMethodFormChange": "Form Change",
  "pokedexMoveMethodSpecial": "Special",
  "pokedexMoveDamagePhysical": "Physical",
  "pokedexMoveDamageSpecial": "Special",
  "pokedexMoveDamageStatus": "Status"
};
